import { Telescope, LogOut, Library, Sparkles, Layers, CreditCard, Image as ImageIcon } from "lucide-react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "@/lib/auth";
import { api } from "@/lib/api";
import { Toaster } from "@/components/ui/sonner";

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const [billing, setBilling] = useState(null);
  const nav = useNavigate();
  const onLogout = () => { logout(); nav("/login"); };

  useEffect(() => {
    if (!user) return;
    api.get("/billing/me").then((r) => setBilling(r.data)).catch(() => {});
    const t = setInterval(() => api.get("/billing/me").then((r) => setBilling(r.data)).catch(() => {}), 30000);
    return () => clearInterval(t);
  }, [user]);

  return (
    <div className="min-h-screen relative">
      <div className="starfield" aria-hidden />
      <header className="sticky top-0 z-40 glass border-b border-white/5">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-3 group" data-testid="header-logo-link">
            <div className="w-9 h-9 rounded-md border border-white/10 grid place-items-center bg-gradient-to-br from-violet-500/30 to-blue-500/10 group-hover:from-violet-500/50 transition-colors">
              <Telescope className="w-4 h-4 text-violet-200" strokeWidth={1.5} />
            </div>
            <div className="leading-tight">
              <div className="font-medium tracking-tight text-base">AstroLift</div>
              <div className="label-eyebrow text-[0.6rem]">Observatoire numérique</div>
            </div>
          </Link>
          <nav className="hidden md:flex items-center gap-1 flex-1 justify-center">
            <NavLink to="/" end className={({isActive}) => `px-3 py-1.5 rounded-md text-sm transition-colors ${isActive ? "bg-white/5 text-white" : "text-muted-foreground hover:text-white"}`} data-testid="nav-dashboard">
              <span className="inline-flex items-center gap-2"><Sparkles className="w-3.5 h-3.5" />Studio</span>
            </NavLink>
            <NavLink to="/batch" className={({isActive}) => `px-3 py-1.5 rounded-md text-sm transition-colors ${isActive ? "bg-white/5 text-white" : "text-muted-foreground hover:text-white"}`} data-testid="nav-batch">
              <span className="inline-flex items-center gap-2"><Layers className="w-3.5 h-3.5" />Lot</span>
            </NavLink>
            <NavLink to="/library" className={({isActive}) => `px-3 py-1.5 rounded-md text-sm transition-colors ${isActive ? "bg-white/5 text-white" : "text-muted-foreground hover:text-white"}`} data-testid="nav-library">
              <span className="inline-flex items-center gap-2"><Library className="w-3.5 h-3.5" />Médiathèque</span>
            </NavLink>
            <NavLink to="/gallery" className={({isActive}) => `px-3 py-1.5 rounded-md text-sm transition-colors ${isActive ? "bg-white/5 text-white" : "text-muted-foreground hover:text-white"}`} data-testid="nav-gallery">
              <span className="inline-flex items-center gap-2"><ImageIcon className="w-3.5 h-3.5" />Galerie</span>
            </NavLink>
            <NavLink to="/pricing" className={({isActive}) => `px-3 py-1.5 rounded-md text-sm transition-colors ${isActive ? "bg-white/5 text-white" : "text-muted-foreground hover:text-white"}`} data-testid="nav-pricing">
              <span className="inline-flex items-center gap-2"><CreditCard className="w-3.5 h-3.5" />Tarifs</span>
            </NavLink>
          </nav>
          <div className="flex items-center gap-3">
            {billing && (
              <Link to="/pricing" data-testid="quota-pill" className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/10 text-[11px] hover:bg-white/5 transition-colors">
                <span className="label-eyebrow">{billing.is_admin ? "Admin" : billing.plan_label}</span>
                <span className="font-mono text-muted-foreground">
                  · {billing.is_admin ? "∞" : `${billing.used_this_month}/${billing.monthly_quota}`}
                </span>
              </Link>
            )}
            <button onClick={onLogout} className="px-3 py-1.5 rounded-md text-sm border border-white/10 hover:bg-white/5 inline-flex items-center gap-2" data-testid="logout-btn">
              <LogOut className="w-3.5 h-3.5" /> Quitter
            </button>
          </div>
        </div>
      </header>
      <main className="relative max-w-7xl mx-auto px-6 py-8">{children}</main>
      <Toaster theme="dark" />
    </div>
  );
}
